module.exports = __webpack_public_path__ + "img/FUK.7cb4cf95.png";